import { getUnitForKey } from "../../charts/domain/domain-utils";

const isValidValue = (v) => v !== null && v !== undefined && !Number.isNaN(v);

const CustomTooltip = ({
  active,
  payload,
  label,
  dataConfig = {},
  unitOverride,
  preferredDataKey = null,
  hideWhenNoPreferred = false,
  decimals = null,
}) => {
  if (!active || !payload || !payload.length) return null;
  if (hideWhenNoPreferred && !preferredDataKey) return null;

  let item = null;

  if (preferredDataKey) {
    item = payload.find((p) => String(p.dataKey) === preferredDataKey) || null;
    if (!item) return null;
  } else {
    item =
      payload.find((p) => !String(p.dataKey).includes("__bridge")) || payload[0];
  }

  const { dataKey, value, color } = item;
  const cfg = dataConfig?.[dataKey] || {};
  const name = cfg.name || item.name || dataKey;
  const unit = unitOverride ?? getUnitForKey?.(dataKey, value) ?? "";
  const shown =
    decimals != null && Number.isFinite(Number(value)) ? Number(value).toFixed(decimals) : value;

  return (
    <div className="tooltip-container">
      <p className="tooltip-label">{label}</p>
      <p className="tooltip-value" style={{ color: cfg.color || color }}>
        {name} {isValidValue(value) ? `${shown}${unit ? ` ${unit}` : ""}` : "-"}
      </p>
    </div>
  );
};

export default CustomTooltip;
